export default __webpack_public_path__ + "static/media/guide-5.e31b14af.png";